export const TurnRight = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    style={{
      width: '1.5rem',
      height: '1.5rem',
      transform: 'scaleX(-1)',
    }}
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='m9 9 6-6m0 0 6 6m-6-6v12a6 6 0 0 1-12 0v-3'
    />
  </svg>
);

export const TurnLeft = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    style={{
      width: '1.5rem',
      height: '1.5rem',
    }}
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='m9 9 6-6m0 0 6 6m-6-6v12a6 6 0 0 1-12 0v-3'
    />
  </svg>
);

export const UploadIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    style={{
      width: '1.5rem',
      height: '1.5rem',
    }}
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15'
    />
  </svg>
);

export const UploadAllIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    style={{
      width: '1.5rem',
      height: '1.5rem',
    }}
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m0-3-3-3m0 0-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75'
    />
  </svg>
);
